/**
 * Session expiry and the app-wide event that publishes it.
 *
 * A 401 from any API call is unambiguous: the session that made the call is gone. The API layer
 * reports every 401 here, once, and this module dispatches {@link SESSION_EXPIRED_EVENT} on
 * `document.body`, so the shell can replace the page instead of leaving every list quietly
 * empty.
 */
export const SESSION_EXPIRED_EVENT = 'session/expired';

// One-way for the life of the page: without a new login, retrying cannot change the answer.
let expired = false;

export const session = {
  isExpired: () => expired,

  reportUnauthorized: () => {
    if (expired) {
      return;
    }
    expired = true;
    document.body.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
  },
};
